import { atom } from "jotai";

export const listMemberAtom = atom<any[] | []>([]);
